import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import {
  CaseStudiesImageCard,
  CaseStudyHeading,
  BackgroundWithCurve,
  Section,
} from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const Americana = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Americana',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Retail & E-Commerce',
                path: '/industries/retail-ecommerce',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center  bg-white shadow-[0px_0px_4px_1px_rgba(0,0,0,0.25)] h-16 w-16 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.AmericanaLogo ? (
                <img
                  className="h-14 w-14 md:h-16 md:w-16 lg:h-20 lg:w-20 object-contain"
                  src={imagePath?.AmericanaLogo}
                  alt="Americana Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading
                title="Americana"
                desc="Product Campaign Using WebAR"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {/* Play Icon */}
              {videoPath?.AmericanaVideo && (
                <video
                  src={videoPath.AmericanaVideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Overview"
            subtitle="Web based AR experience for festivals."
            content="Objective of this project is to develop a web-based experience designed for users to understand
            and interact with the Global organization's product offerings without having to change the end-
            user's behavior. It is intended to showcase the product's features and benefits in a short window
            of time."
          />

          <Section
            title="Execution"
            content={[
              'This customer selected the Spatial Grid platform to develop web-based AR experience triggeredthrough a QR code. When the user scans the QR code an AI generated persona will appeardescribing features of the product. The customer was able to leverage AI plug-ins available inthe Spatial Grid platform to include additional animations required to provide an engagingexperience to the end-user.',
              'In this application, the platforms capabilities were leveraged to deliver a seamless web-based AR experience, enabling easy access without the need for app downloads. The solution captured detailedinsights into user interactions, providing valuable data on engagement and usage patterns. AI-driven animations and simulations were used to bring the created avatars to life, enhancing personalization and immersion. Additionally, advanced platform features enabled the creation of highly realistic scenesand environments, resulting in a visually rich and engaging AR experience.',
            ]}
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.americana1}
                title="AR Experience Interface"
              />
              <CaseStudiesImageCard
                image={imagePath?.americana2}
                title="AR Recipe Discovery Experience"
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              content="Development of the project from concept to deployment was completed in 11 days reducing the TCO significantly. Increased footfall on product range in store."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

<CaseStudyHeading />;
<CaseStudiesImageCard />;
export default Americana;
